import addError from '../../../utils/error.jsx';

export function request(sportId, marketTemplateId, eventTemplateId, selection) {
    return {
        type: 'SELECTION_TEMPLATES_CREATION_REQUEST',
        sportId,
        marketTemplateId,
        eventTemplateId,
        selection
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'SELECTION_TEMPLATES_CREATION_ERROR',
        errors
    };
}

export function finish(marketTemplateId, selection) {
    return {
        type: 'SELECTION_TEMPLATES_CREATION_FINISH',
        marketTemplateId,
        selection
    };
}
